export function isIntercomEnabled() {
  return "Intercom" in window && JSON.stringify((window as any).intercomSettings) !== JSON.stringify({});
}
